import { Locale } from './messages';

export function localeTag(locale: Locale): string {
  return locale === 'en' ? 'en-US' : 'th-TH';
}

export function formatMoney(amount: number, locale: Locale): string {
  const formatted = amount.toLocaleString(localeTag(locale));
  return locale === 'en' ? `${formatted} THB` : `${formatted} บาท`;
}

function hasTimeOptions(options?: Intl.DateTimeFormatOptions): boolean {
  if (!options) return false;
  return (
    options.timeStyle !== undefined ||
    options.hour !== undefined ||
    options.minute !== undefined ||
    options.second !== undefined
  );
}

export function formatDate(
  value: Date | string,
  locale: Locale,
  options?: Intl.DateTimeFormatOptions
): string {
  const date = value instanceof Date ? value : new Date(value);
  const tag = localeTag(locale);
  if (hasTimeOptions(options)) {
    return date.toLocaleString(tag, options);
  }
  return date.toLocaleDateString(tag, options);
}

export function formatDateShort(value: Date | string, locale: Locale): string {
  return formatDate(value, locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatMonthYear(date: Date, locale: Locale): string {
  return date.toLocaleDateString(localeTag(locale), {
    month: 'long',
    year: 'numeric',
  });
}

export function weekdayLabels(locale: Locale): string[] {
  if (locale === 'en') return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  return ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'];
}
